/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ScheduleEvent,
  ScheduleEvent$inboundSchema,
  ScheduleEvent$Outbound,
  ScheduleEvent$outboundSchema,
} from "./scheduleevent.js";

/**
 * The schedule value of
 */
export type Schedule = {
  /**
   * The events of the schedule (which may be empty)
   */
  events?: Array<ScheduleEvent> | undefined;
};

/** @internal */
export const Schedule$inboundSchema: z.ZodType<
  Schedule,
  z.ZodTypeDef,
  unknown
> = z.object({
  events: types.optional(z.array(ScheduleEvent$inboundSchema)),
});
/** @internal */
export type Schedule$Outbound = {
  events?: Array<ScheduleEvent$Outbound> | undefined;
};

/** @internal */
export const Schedule$outboundSchema: z.ZodType<
  Schedule$Outbound,
  z.ZodTypeDef,
  Schedule
> = z.object({
  events: z.array(ScheduleEvent$outboundSchema).optional(),
});

export function scheduleToJSON(schedule: Schedule): string {
  return JSON.stringify(Schedule$outboundSchema.parse(schedule));
}
export function scheduleFromJSON(
  jsonString: string,
): SafeParseResult<Schedule, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Schedule$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Schedule' from JSON`,
  );
}
